/**
 * @generated SignedSource<<45fc687ba024e2f801adda6840636208>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type fetchTicketNotificationPrefsQuery$variables = {};
export type fetchTicketNotificationPrefsQuery$data = {
  readonly viewer: {
    readonly ticketingNotificationPrefs: {
      readonly emailAssigned: boolean | null;
      readonly emailMentioned: boolean | null;
      readonly emailCustomerReplied: boolean | null;
      readonly emailWatching: boolean | null;
      readonly emailSlaBreached: boolean | null;
      readonly inAppAssigned: boolean | null;
      readonly inAppMentioned: boolean | null;
      readonly inAppCustomerReplied: boolean | null;
      readonly inAppWatching: boolean | null;
      readonly inAppSlaBreached: boolean | null;
    } | null;
  } | null;
};
export type fetchTicketNotificationPrefsQuery = {
  variables: fetchTicketNotificationPrefsQuery$variables;
  response: fetchTicketNotificationPrefsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "NotificationPrefs",
  "kind": "LinkedField",
  "name": "ticketingNotificationPrefs",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAssigned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailMentioned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailCustomerReplied",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailWatching",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailSlaBreached",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppAssigned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppMentioned",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppCustomerReplied",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppWatching",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inAppSlaBreached",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "fetchTicketNotificationPrefsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "fetchTicketNotificationPrefsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cfec91b4a2030e162494b42f64152801",
    "id": null,
    "metadata": {},
    "name": "fetchTicketNotificationPrefsQuery",
    "operationKind": "query",
    "text": "query fetchTicketNotificationPrefsQuery {\n  viewer {\n    ticketingNotificationPrefs {\n      emailAssigned\n      emailMentioned\n      emailCustomerReplied\n      emailWatching\n      emailSlaBreached\n      inAppAssigned\n      inAppMentioned\n      inAppCustomerReplied\n      inAppWatching\n      inAppSlaBreached\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2de5f7e45d09f0d5ffa29d6929033bb3";

export default node;
